import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtDate } from "@/lib/format";
import { useState } from "react";

const toISO = (d) =>
  d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "";

export default function DatePicker({ value, onChange, placeholder = "Pick date", testid = "date-picker", className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testid} type="button" className={`al-input text-left flex items-center gap-2 ${className}`}>
          <CalendarDays className="w-3.5 h-3.5 text-amber-400 shrink-0" />
          <span className={value ? "text-slate-200" : "text-slate-500"}>{value ? fmtDate(value) : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0 bg-[#0E131F] border border-slate-800 rounded-md shadow-xl">
        <Calendar
          mode="single"
          selected={value ? new Date(value) : undefined}
          defaultMonth={value ? new Date(value) : undefined}
          onSelect={(d) => { if (d) { onChange(toISO(d)); setOpen(false); } }}
          initialFocus
          classNames={{
            caption_label: "text-sm font-medium text-slate-200",
            nav_button: "h-7 w-7 bg-transparent border border-slate-700 rounded-md text-slate-300 hover:bg-slate-800 inline-flex items-center justify-center transition-colors",
            head_cell: "text-slate-500 rounded-md w-8 font-normal text-[0.75rem]",
            day: "h-8 w-8 p-0 font-normal rounded-md text-slate-300 hover:bg-slate-800 inline-flex items-center justify-center transition-colors aria-selected:opacity-100",
            day_selected: "bg-amber-500 text-[#0A0D14] font-semibold hover:bg-amber-500 hover:text-[#0A0D14] focus:bg-amber-500 focus:text-[#0A0D14]",
            day_today: "border border-amber-500/50 text-amber-400",
            day_outside: "text-slate-600 opacity-50",
            day_disabled: "text-slate-700 opacity-40",
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
